import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from "vuex";
import { clearCache } from "@/api/user";
export default {
  name: "tags",
  data: function data() {
    return {
      active: "",
      contentmenuX: "",
      contentmenuY: "",
      contextmenuFlag: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.setActive();
  },
  watch: {
    tag: function tag() {
      this.setActive();
    },
    contextmenuFlag: function contextmenuFlag() {
      window.addEventListener("mousedown", this.watchContextmenu);
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(["tagWel", "tagList", "tag", "website"])), mapState({
    showTag: function showTag(state) {
      return state.common.showTag;
    }
  })), {}, {
    tagLen: function tagLen() {
      return this.tagList.length || 0;
    }
  }),
  methods: {
    generateTitle: function generateTitle(item) {
      return this.$router.$avueRouter.generateTitle(item.label, (item.meta || {}).i18n);
    },
    watchContextmenu: function watchContextmenu(event) {
      if (!this.$el.contains(event.target) || event.button !== 0) {
        this.contextmenuFlag = false;
      }

      window.removeEventListener("mousedown", this.watchContextmenu);
    },
    handleContextmenu: function handleContextmenu(event) {
      var target = event.target; // 解决 https://github.com/d2-projects/d2-admin/issues/54

      var flag = false;
      if (target.className.indexOf("el-tabs__item") > -1) flag = true;else if (target.parentNode.className.indexOf("el-tabs__item") > -1) {
        target = target.parentNode;
        flag = true;
      }

      if (flag) {
        event.preventDefault();
        event.stopPropagation();
        this.contentmenuX = event.clientX;
        this.contentmenuY = event.clientY;
        this.tagName = target.getAttribute("aria-controls").slice(5);
        this.contextmenuFlag = true;
      }
    },
    //激活当前选项
    setActive: function setActive() {
      this.active = this.tag.value;
    },
    menuTag: function menuTag(value, action) {
      if (action === "remove") {
        var _this$findTag = this.findTag(value),
            tag = _this$findTag.tag,
            key = _this$findTag.key;

        this.$store.commit("DEL_TAG", tag);

        if (tag.value === this.tag.value) {
          tag = this.tagList[key === 0 ? key : key - 1]; //如果关闭本标签让前推一个

          this.openTag(tag);
        }
      }
    },
    openTag: function openTag(item) {
      var tag;

      if (item.name) {
        tag = this.findTag(item.name).tag;
      } else {
        tag = item;
      }

      this.$router.push({
        path: this.$router.$avueRouter.getPath({
          name: tag.label,
          src: tag.value
        }, tag.meta),
        query: tag.query
      });
    },
    closeOthersTags: function closeOthersTags() {
      this.contextmenuFlag = false;
      this.$store.commit("DEL_TAG_OTHER");
    },
    findTag: function findTag(value) {
      var tag, key;
      this.tagList.map(function (item, index) {
        if (item.value === value) {
          tag = item;
          key = index;
        }
      });
      return {
        tag: tag,
        key: key
      };
    },
    closeAllTags: function closeAllTags() {
      this.contextmenuFlag = false;
      this.$store.commit("DEL_ALL_TAG");
      this.$router.push({
        path: this.$router.$avueRouter.getPath({
          src: this.tagWel.value
        }),
        query: this.tagWel.query
      });
    },
    clearCacheTags: function clearCacheTags() {
      var _this = this;

      this.$confirm("是否需要清除缓存?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        clearCache().then(function () {
          _this.contextmenuFlag = false;

          _this.$message.success('清除完毕');
        });
      });
    }
  }
};